import gql from "graphql-tag";

export const CHANGE_REPORT_STEP_MUTATION = gql`
  mutation ChangeReportStep($reportId: ID!, $step: ReportStep!) {
    changeReportStep(reportId: $reportId, step: $step)
  }
`;
